module.exports = __webpack_public_path__ + "static/img/fill-warning.c11ce953.svg";